const TestItems = [
  {
    id: 'rec0uAoxcnldjv7hT',
    fields: {
      Price: 5.5,
      Unit: 'loaf',
      Category: ['rec3hYrmGK9w6MDHw'],
      Notes: 't, fr, sun only',
      Name: 'Seeded Loaf',
      Vendor: ['recNEPHNh7QdUjv5O'],
    },
    createdTime: '2020-03-20T02:20:28.000Z',
    quantity: '1',
  },
  {
    id: 'recAiBTASkoRqXYHF',
    fields: {
      Price: 2.29,
      Unit: 'lb',
      Category: ['recXNascqogVMj1Xf'],
      Name: 'Mandarins',
      Vendor: ['recKggha2C8dk8kxn'],
    },
    createdTime: '2020-03-20T02:20:28.000Z',
    quantity: '1',
  },
  {
    id: 'recAocya9vUA0GUNN',
    fields: {
      Price: 5.5,
      Unit: 'loaf',
      Category: ['rec3hYrmGK9w6MDHw'],
      Notes: 't, fr, sun only',
      Name: 'House Loaf',
      Vendor: ['recNEPHNh7QdUjv5O'],
    },
    createdTime: '2020-03-20T02:20:28.000Z',
    quantity: '1',
  },
  {
    id: 'recD98BuXzXt3t7T9',
    fields: {
      Price: 2.5,
      Unit: 'lb',
      Category: ['recDTibzP8cgaqY5t'],
      Name: 'Unsalted Butter',
      Vendor: ['recGXyp3d65PIC0b2'],
    },
    createdTime: '2020-03-20T02:20:28.000Z',
    quantity: '1',
  },
  {
    id: 'recH6yC7RKYChTXeF',
    fields: {
      Price: 7.37,
      Unit: '16 oz ',
      Category: ['recDTibzP8cgaqY5t'],
      Name: 'Truffle Burrata',
      Vendor: ['recPhdsa5wEn11FCm'],
    },
    createdTime: '2020-03-20T02:20:28.000Z',
    quantity: '1',
  },
  {
    id: 'recKnuklgz5IlMCGx',
    fields: {
      Price: 15,
      Unit: 'lb',
      Category: ['recnJRV4RWDmeowRr'],
      Name: 'Blac Tiger Shrimp (frozen, raw)',
      Vendor: ['recGXyp3d65PIC0b2'],
    },
    createdTime: '2020-03-20T02:20:28.000Z',
    quantity: '1',
  },
  {
    id: 'recSnOy2r7TXnARPi',
    fields: {
      Price: 5.28,
      Unit: 'lb',
      Category: ['recDTibzP8cgaqY5t'],
      Name: 'Fontina',
      Vendor: ['recPhdsa5wEn11FCm'],
    },
    createdTime: '2020-03-20T02:20:28.000Z',
    quantity: '1',
  },
  {
    id: 'recZ40fEzs9XiDr6s',
    fields: {
      Price: 4.42,
      Unit: 'lb',
      Category: ['recDTibzP8cgaqY5t'],
      Name: 'Fresh Mozzarella Log',
      Vendor: ['recPhdsa5wEn11FCm'],
    },
    createdTime: '2020-03-20T02:20:28.000Z',
    quantity: '1',
  },
]

export default TestItems
